// Copyright (c) 2022, 37.78 Tecnologia Ltda. All rights reserved.

const MuiContainer = {
  styleOverrides: {
    root: ({ ownerState, theme: { breakpoints } }) => ({
      ...(!ownerState.disableGutters && {
        [breakpoints.up("xs")]: {
          paddingLeft: "16px",
          paddingRight: "16px",
        },
        [breakpoints.up("sm")]: {
          paddingLeft: "20px",
          paddingRight: "20px",
        },
        [breakpoints.up("md")]: {
          paddingLeft: "40px",
          paddingRight: "40px",
        },
        [breakpoints.up("xl")]: {
          paddingLeft: "228px",
          paddingRight: "228px",
        },
      }),
    }),
  },
};

export default MuiContainer;
